<template>
  <div class="gemeosBox mb-2">
    <div class="gemeosBox_header mb-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="col">
          <h2 class="gemeosBox_header_title">
            Gêmeos
          </h2>
        </div>
      </div>
    </div>
    <div class="row pl-4">
      <div class="form-group">
        <label
          class="d-block label"
          for="gemeosSim">Possui Gêmeos?</label>
        <span class="custom-control custom-radio custom-control-inline">
          <input
            id="gemeosSim"
            v-model="localData.gemeos"
            type="radio"
            name="gemeosSim"
            :value="true"
            class="custom-control-input"
            @change="changed">
          <label
            class="custom-control-label"
            for="gemeosSim">Sim</label>
        </span>

        <span class="custom-control custom-radio custom-control-inline">
          <input
            id="gemeosNao"
            v-model="localData.gemeos"
            type="radio"
            name="gemeosNao"
            :value="false"
            class="custom-control-input"
            @change="changed">
          <label
            class="custom-control-label"
            for="gemeosNao">Não</label>
        </span>
      </div>

      <div class="col-sm-4 col-lg-3">
        <div class="form-group">
          <div class="form-group">
            <label class="label"
                   for="qtd_gemeos">Quantos Gêmeos</label>
            <div class="col-12 m-0 p-0 d-inline-flex justify-content-between">
              <div class="col-4 m-0 p-0">
                <input id="qtd_gemeos"
                       v-model="localData.qtd_gemeos"
                       v-validate="'min_value:2'"
                       :class="{ 'is-invalid': errors.has('qtd_gemeos') }"
                       class="form-control form-control-sm"
                       name="qtd_gemeos"
                       placeholder="00"
                       type="number"
                       min="2"
                       :disabled="!localData.gemeos"
                       @change="changed()">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'GemeosObito',
    inject: ['$validator'],
    props: {
      data: { type: String, default: () => '' },
      readOnly: { type: Boolean, default: () => false },
      propCorrecoes: {type: Object, default: () => ({})},
      
    },
    data () {
      return {
        localData: {
          gemeos: false,
          qtd_gemeos: null,
        }
      }
    },
    watch: {
      data () {
        this.verifyGemeo() 
      }
    },
    mounted () {
      this.verifyGemeo()
    },
    methods: {
      changed () {
        if (!this.localData.gemeos) {
          this.localData.qtd_gemeos = null
        }
        this.$emit('addGemeo', this.localData)
      },
      verifyGemeo () {
        if (this.data && this.data >= 2) {
          this.localData.qtd_gemeos = this.data
          this.localData.gemeos = true
        }
        this.$emit('addGemeo', this.localData)
      },
    },
  }
</script>

<style lang="scss">
  @import "@/scss/_utilities/_exports";

  .gemeosBox {
    &_header {
      @extend %titleBox;
      background-color: $color-gray-light;

      &_title {
        @extend %titleBox_title;
      }

      &_error {
        color: #8B0000;
      }
    }
  }
</style>
